import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

export type ErrorButtonType =
    "Reload" |
    "Close"

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  shown = new BehaviorSubject<boolean>(false);
  message: string;
  onClose: () => void;
  errorButtonType: ErrorButtonType;
  constructor() { }

  showClosableError(
    message: string,
    onClose: () => void
  ) {
    this.shown.next(true);
    this.message = message;
    
    this.errorButtonType = "Close";
    this.onClose = onClose;
  }
}